import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { ClientType } from "../../app/types/genericTables.types";

type UseClientsType = {
  clientsList: ClientType[];
  get: (id: ClientType["id"]) => ClientType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useClient = create<UseClientsType>((set, get) => ({
  loading: false,
  clientsList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().clientsList.find((client) => client.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/clientes";
      const { data: response } = await getData(endpoint);
      set(() => ({
        clientsList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useClient:", error);
      set({ loading: false });
    }
  },
}));
